module.exports = __webpack_public_path__ + "static/media/PM90.cb3aca33.png";